export const setCurrentLanguage = value => {
  window.UFE.locale = value
}

export const getCurrentLanguage = () => {
  return window.UFE.locale
}

export const getDefaultLanguage = () => window.UFE && window.UFE.defaultLocale
